import React from "react";
import { Link } from "react-router-dom";

const ServiceOne = () => {
  return (
    <div className="service-area-1 space overflow-hidden">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7">
            <div className="title-area text-center">
              <span className="sub-title">
                <img src="assets/img/icon/title_left.svg" alt="Ícone de Diferenciais Rocvel" />
                Nossos Diferenciais
              </span>
              <h2 className="sec-title style2">
  Conectamos os melhores talentos às melhores operações, com uma metodologia única e exclusiva de triagem com foco nos resultados.
</h2>
              <p className="sec-text mt-3">
                Unimos processos modernos orientados por performance a uma visão corporativa premium e humanizada.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row gx-30 gy-30 justify-content-center">
          <div className="col-md-6">
            <div className="service-card">
              <div className="service-card_img">
                <img src="assets/img/home/5/1.png" alt="Atendimento Consultivo de RH Rocvel" />
              </div>
              <div className="service-card_content">
                <h4 className="service-card_title">
                  <Link to="https://api.whatsapp.com/send?phone=5511915259017&text=Olá!%20Gostaria%20de%20mais%20informações.">Atendimento Consultivo</Link>
                </h4>
                <p className="service-card_text">
                  Oferecemos um suporte totalmente personalizado de ponta a ponta. Nossa equipe estuda a fundo o ecossistema e as necessidades reais da sua empresa antes de desenhar a solução ideal.
                </p>
                <Link to="https://api.whatsapp.com/send?phone=5511915259017&text=Olá!%20Gostaria%20de%20mais%20informações." className="link-btn">
                  Saber Mais <i className="fas fa-arrow-right" />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="service-card">
              <div className="service-card_img">
                <img src="assets/img/home/5/2.png" alt="Banco de Talentos Atualizado Rocvel" />
              </div>
              <div className="service-card_content">
                <h4 className="service-card_title">
                  <Link to="https://api.whatsapp.com/send?phone=5511915259017&text=Olá!%20Gostaria%20de%20mais%20informações.">Banco de Talentos Vivo</Link>
                </h4>
                <p className="service-card_text">
                  Contamos com uma base de profissionais estratégica e constantemente atualizada. Isso nos permite antecipar demandas e encontrar perfis altamente qualificados com agilidade.
                </p>
                <Link to="https://api.whatsapp.com/send?phone=5511915259017&text=Olá!%20Gostaria%20de%20mais%20informações." className="link-btn">
                  Saber Mais <i className="fas fa-arrow-right" />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="service-card">
              <div className="service-card_img">
                <img src="assets/img/home/5/3.png" alt="Recrutamento em Escala Rocvel" />
              </div>
              <div className="service-card_content">
                <h4 className="service-card_title">
                  <Link to="https://api.whatsapp.com/send?phone=5511915259017&text=Olá!%20Gostaria%20de%20mais%20informações.">Recrutamento em Escala</Link>
                </h4>
                <p className="service-card_text">
                  Possuímos forte capacidade técnica e estrutura flexível para realizar contratações massivas sem perder o rigor e mantendo uma entrega extremamente ágil no mercado.
                </p>
                <Link to="https://api.whatsapp.com/send?phone=5511915259017&text=Olá!%20Gostaria%20de%20mais%20informações." className="link-btn">
                  Saber Mais <i className="fas fa-arrow-right" />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="service-card">
              <div className="service-card_img">
                <img src="assets/img/home/5/4.png" alt="Foco na Retenção de Talentos Rocvel" />
              </div>
              <div className="service-card_content">
                <h4 className="service-card_title">
                  <Link to="https://api.whatsapp.com/send?phone=5511915259017&text=Olá!%20Gostaria%20de%20mais%20informações.">Foco em Retenção</Link>
                </h4>
                <p className="service-card_text">
                  Nossos processos garantem a máxima aderência cultural dos candidatos. Alinhamos competências técnicas e comportamentais para diminuir o turnover da sua operação.
                </p>
                <Link to="https://api.whatsapp.com/send?phone=5511915259017&text=Olá!%20Gostaria%20de%20mais%20informações." className="link-btn">
                  Saber Mais <i className="fas fa-arrow-right" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceOne;